module.exports = __webpack_public_path__ + "static/media/my2.b34fc1be.svg";